import { useNavigate } from "react-router-dom"
import image from "../../assets/images/info-icon.png"
import { useState } from "react"
import { makePostRequest } from "request"
import { ToastContainer, toast } from 'react-toastify';

import { useDispatch, } from "react-redux";
import { setTepngUser } from "../../store/tepngUser";
import { setRoles } from "../../store/roles";
import Modal from 'react-modal'
import { customStyles } from "helpers";

const VendorCodeValidation = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // const user = useSelector((state: any) => state.tepngUser.value);
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [vendorCode, setVendorCode] = useState("")
    
    const handleValidateVendorCode = () => {
        setIsLoading(true)
        const data = {
            vendorCode: vendorCode
        }
        var request:Record<string, any> = {
            what: "VendorCodeValidation",
            data: data
        }
    
        makePostRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                toast.success(response.msg)

                const res = response.data.data
                if(res){
                    dispatch(setTepngUser(res.user))
                    dispatch(setRoles(res.roles))
                    
                    if(res.acceptsConsentTerms === false) navigate("/policy");
                    else {
                        // check if seesion storage vendorCode is set, if not set, set it
                        if(sessionStorage.getItem('vendorCode') === null) sessionStorage.setItem('vendorCode', res.user.vendorCode)   

                        // Redirect user
                        const redirectURL = sessionStorage.getItem("redirectURL")
                        const roles = res.roles
                        if(redirectURL !== null) window.location.replace(redirectURL)
                        else {
                            // to avoid thirdparty users from navigating to Supplier page first
                            if(roles.find((role: string) => role.toLowerCase() === "freightforwarder")) navigate("/freightforwarder/dashboard")
                                else if(roles.find((role: string) => role.toLowerCase() === "localclearingagent")) navigate("/localclearingagent/dashboard")
                                else navigate(`/${roles[0].toLowerCase()}/dashboard`)}                                    
                            }
                        }
                        sessionStorage.removeItem("redirectURL")
            }).catch((error:any) => {toast.error(error.msg); setIsLoading(false)});
    }

    return (
        <>
            <div className="blocked-container">
                <div>
                    <img src={image} alt="unauthorized" width="40px" />
                    <h3>Vendor Code Required</h3>
                    <p>Kindly provide your valid code to access the portal.</p>
                    <div className="d-flex-2 gap-2" style={{marginBottom: "16px"}}>
                        <input 
                        disabled={isLoading} 
                        className="custom-input" 
                        type="text" style={{height: "35px"}} 
                        placeholder="Enter Vendor Code" 
                        onChange={(e) => setVendorCode(e.target.value)}
                        />
                        <button onClick={() => handleValidateVendorCode()} disabled={isLoading || vendorCode.length < 4} className="custom-button orange" style={{margin: 0}}>{isLoading ? "Validating..." : "Continue"}</button>
                    </div>

                    <button 
                    className="link-button blue" 
                    style={{textDecoration: "underline", display: "flex", justifyContent: "center", width: "100%"}} 
                    onClick={() => setIsOpenModal(true)}>Want to add a new phone number for login?</button>
                    {/* <a href="https://mysignins.microsoft.com/security-info" target="_blank" rel="noreferrer" className="link-button blue" style={{fontSize: "12px", textDecoration: "underline"}}>Want to add a new phone number for login?</a> */}
                    
                </div>
                
            </div>    
            <ToastContainer />   

            <Modal isOpen={isOpenModal} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Confirm your Microsoft Account Status</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => setIsOpenModal(false)}>close</span>
                </div>
                <p className="small-text text-grey">Kindly select the right option to be redirect to the correct page to proceed.</p>
                <div className="modal-body">
                    <div className="custom-button orange-outline mt-2" style={{padding: "16px", justifyContent: "center", textWrap: "wrap", textAlign: "center"}} onClick={() => window.location.replace("https://mysignins.microsoft.com/security-info")}>I have a Work (Organization) Account/ Profiled on TotalEnergies Tenant</div>
                    <div className="custom-button orange-outline mt-1" style={{padding: "16px", justifyContent: "center"}} onClick={() => window.location.replace("https://account.live.com/proofs/manage/additional")}>I have a Personal Microsoft Account</div>
                </div>
                {/* <div className="modal-footer">
                    <button className="custom-button grey-outline"
                        onClick={() => setIsOpenModal(false)}>Cancel</button>
                    <button type="submit" className="custom-button orange"
                        onClick={() => {}}>Submit</button>
                </div> */}
            </Modal>  
        </>
    )
}

export default VendorCodeValidation